import React, {useCallback, useContext} from 'react';
import cx from 'classnames';
import {OverviewCardsList} from './OverviewCardsList';
import {AutomationOverviewHeader} from './AutomationOverviewHeader';
import {RuleType} from '../../../../enums';
import {AIAskBlock} from '../../../common/AIAskBlock/AIAskBlock';
import styles from '../../styles.module.scss';
import {AutomationsOverviewContext} from '../../RulesListDialog';
import {AIRulesMonitoring} from '../../../common/AIAskBlock/enums';
import {monitorAction} from '../../../../../../services/datadog';
import {getRuleKeyByValue} from '../../../../utils';
import ruleDialogStyles from '../../../RuleDialog/styles.module.scss';
import {Loader} from '../../../../../OnboardingDialog/components';
import {loaderSize} from '../../../../constants';

export const AutomationsOverview = ({
    type,
    session,
    isLoading = false
}: {
    type: RuleType;
    session: string;
    isLoading?: boolean;
}) => {
    const [showAI, setShowAI] = React.useState(false);
    const {toggleKeyboardInteraction} = useContext(AutomationsOverviewContext);

    const onAIInputFocus = useCallback(
        () => toggleKeyboardInteraction(true),
        [toggleKeyboardInteraction]
    );

    const onAIInputBlur = useCallback(
        () => toggleKeyboardInteraction(false),
        [toggleKeyboardInteraction]
    );

    const onAIClick = () => {
        if (!showAI) {
            // send datadog event only when AI is opened
            monitorAction(AIRulesMonitoring.showAI, {ruleType: getRuleKeyByValue(type)});
        }
        setShowAI(!showAI);
    };

    if (isLoading) {
        return (
            <div className={cx('reactComp', styles.rulesOverview, ruleDialogStyles.loaderOverlay)}>
                <Loader width={loaderSize} height={loaderSize} />
            </div>
        );
    }
    return (
        <div className={cx('reactComp', styles.rulesOverview)}>
            <AutomationOverviewHeader onAIClick={onAIClick} />

            {showAI ? (
                <AIAskBlock
                    onAIInputFocus={onAIInputFocus}
                    onAIInputBlur={onAIInputBlur}
                    componentClasses={styles.aiAskBlock}
                    maxWidth={700}
                    type={type}
                    session={session}
                />
            ) : (
                <OverviewCardsList type={type} session={session} />
            )}
        </div>
    );
};
